import RootLayout from "@/layouts/RootLayout";
import SettingsLayout from "@/layouts/SettingsLayout";
import StateLayout from "@/layouts/StateLayout";
import AuthCallback from "@/pages/AuthCallback";
import CRMErrorPage from "@/pages/crm/CRMErrorPage";
import CRMPage from "@/pages/crm/CRMPage";
import CRMSuccessPage from "@/pages/crm/CRMSuccessPage";
import EnrichPage from "@/pages/EnrichPage";
import Lists from "@/pages/lists/Lists";
import ListDetail from "@/pages/lists/ListsDetail";
import OnBoarding from "@/pages/OnBoarding";
import CampaignListCompanies from "@/pages/predictiveLeads/campaign/CampaignListCompanies";
import CampaignLists from "@/pages/predictiveLeads/campaign/CampaignLists";
import CampaignPaymentError from "@/pages/predictiveLeads/campaign/CampaignPaymentError";
import CampaignPaymentSuccess from "@/pages/predictiveLeads/campaign/CampaignPaymentSuccess";
import CreateCampaign from "@/pages/predictiveLeads/campaign/CreateCampaign";
import UpdateCampaign from "@/pages/predictiveLeads/campaign/UpdateCampaign";
import PredictivePage from "@/pages/predictiveLeads/PredictivePage";
import CreateProduct from "@/pages/predictiveLeads/product/CreateProduct";
import UpdateProduct from "@/pages/predictiveLeads/product/UpdateProduct";
import Search from "@/pages/Search";
import PlansBilling from "@/pages/settings/subscription/PlansBilling";
import SubscriptionError from "@/pages/settings/subscription/SubscriptionError";
import SubscriptionSuccess from "@/pages/settings/subscription/SubscriptionSuccess";
import { createBrowserRouter } from "react-router-dom";

import AuthGuard from "@/components/AuthGuard";

const paymentRoute = "/payment";
const settingRoute = "/settings";
const crmRoute = "/connections";

export const routesPayment = {
  payment: paymentRoute,
  paymentSuccess: paymentRoute + "/success",
  paymentError: paymentRoute + "/error",
};

export const routesSetting = {
  settings: settingRoute,
  plans: settingRoute + "/plans",
  crm: settingRoute + "/connections",
  crmError: crmRoute + "/error",
  crmSuccess: crmRoute + "/success",
};

const predictive = "/predictive";

export const predictiveRoutes = {
  predictive,
  product: {
    create: predictive + "/product/create",
    update: predictive + "/product/:productId/update",
  },
  campaign: {
    create: predictive + "/product/:productId/campaign/create",
    update: predictive + "/product/:productId/campaign/:campaignId/update",
    listOverview: predictive + "/product/:productId/campaign/:campaignId/lists",
    listDetail: predictive + "/product/:productId/campaign/:campaignId/lists/:id",
  },
};

const predictivePayment = {
  predictivePayment: predictive + "/payment",
  predictivePaymentSuccess: predictive + "/payment/success",
  predictivePaymentError: predictive + "/payment/error",
};

export const routes = {
  search: "/",
  enrich: "/enrich",
  alerts: "/alerts",
  lists: "/lists",
  listsDetail: "/lists/:id",
  callback: "/callback",
  profile: "/profile",
  onboarding: "/onboarding",
  ...routesSetting,
  ...routesPayment,
  ...predictiveRoutes,
  ...predictivePayment,
};

export const router = createBrowserRouter([
  {
    path: routes.onboarding,
    element: (
      <AuthGuard>
        <OnBoarding />
      </AuthGuard>
    ),
  },
  {
    path: routesPayment.payment,
    element: (
      <AuthGuard>
        <StateLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: routesPayment.paymentSuccess,
        element: <SubscriptionSuccess />,
      },
      {
        path: routesPayment.paymentError,
        element: <SubscriptionError />,
      },
    ],
  },
  {
    path: routes.predictivePayment,
    element: (
      <AuthGuard>
        <StateLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: routes.predictivePaymentSuccess,
        element: <CampaignPaymentSuccess />,
      },
      {
        path: routes.predictivePaymentError,
        element: <CampaignPaymentError />,
      },
    ],
  },
  {
    path: crmRoute,
    element: (
      <AuthGuard>
        <StateLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: routesSetting.crmError,
        element: <CRMErrorPage />,
      },
      {
        path: routesSetting.crmSuccess,
        element: <CRMSuccessPage />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <RootLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: routes.search,
        element: <Search />,
      },
      {
        path: routes.enrich,
        element: <EnrichPage />,
      },
      {
        path: routes.lists,
        element: <Lists />,
      },
      {
        path: routes.listsDetail,
        element: <ListDetail />,
      },
      {
        path: routes.settings,
        element: <SettingsLayout />,
        children: [
          {
            path: routesSetting.plans,
            element: <PlansBilling />,
          },
          {
            path: routesSetting.crm,
            element: <CRMPage />,
          },
        ],
      },
      {
        path: predictive,
        element: <PredictivePage />,
      },
      {
        path: routes.product.create,
        element: <CreateProduct />,
      },
      {
        path: routes.product.update,
        element: <UpdateProduct />,
      },
      {
        path: routes.campaign.create,
        element: <CreateCampaign />,
      },
      {
        path: routes.campaign.listOverview,
        element: <CampaignLists />,
      },
      {
        path: routes.campaign.listDetail,
        element: <CampaignListCompanies />,
      },
      {
        path: routes.campaign.update,
        element: <UpdateCampaign />,
      },
    ],
  },
  {
    path: routes.callback,
    element: <AuthCallback />,
  },
]);
